const n = (t, e) => {
  Object.keys(t).forEach((r) => {
    const s = t[r];
    e({ key: r, value: s });
  });
}, o = (t, e) => {
  if (t === e)
    return !0;
  const r = Object.keys(t), s = Object.keys(e);
  if (r.length !== s.length)
    return !1;
  for (const c of r)
    if (!Object.prototype.hasOwnProperty.call(e, c) || t[c] !== e[c])
      return !1;
  return !0;
}, l = (t) => {
  const e = {};
  return n(t, ({ key: r, value: s }) => {
    s !== void 0 && (e[r] = s);
  }), e;
};
export {
  o as areObjectsShallowEqual,
  n as objectForEach,
  l as omitUndefinedObjectValues
};
